import Form from "componentsv2/form/Form";
import { useWizard } from "storev2/wizardStore";

async function updateStore({ record, _, field, value }) {
  record.store[field.name] = value;
  record.active[field.name] = value;
  const { updateWizard } = useWizard.getState();
  updateWizard(record);
}

function CustomForm(props) {
  const record = useWizard.getState().record;
  return (
    <Form
      {...props}
      storeId={props.storeId}
      update={updateStore}
      record={record}
    />
  );
}

export default CustomForm;
